import { reloadOnceOnChunkError } from "@/lib/chunk-reload";

type AIChatModule = typeof import("@/components/AIChat");

let aiChatModulePromise: Promise<AIChatModule> | null = null;

/** Single shared import() so AppAiFab and Seating never race two chunk loads. */
export function loadAIChatModule(): Promise<AIChatModule> {
  if (!aiChatModulePromise) {
    aiChatModulePromise = import("@/components/AIChat").catch((error: unknown) => {
      aiChatModulePromise = null;
      throw error;
    });
  }
  return aiChatModulePromise;
}

/** Warm the AI chat chunk before the user opens it (mobile seating header, FAB hover). */
export function preloadAIChat(): void {
  void loadAIChatModule().catch((error: unknown) => {
    reloadOnceOnChunkError(error);
  });
}
